import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { TabViewChangeEvent } from 'primeng/tabview';
import { ListiniService } from 'src/app/services/listini.service';
import { Listino } from 'src/app/models/listino.model';
import { UtilService } from 'src/app/services/util.service';
import { CreaListinoComponent } from './crea/crea-listino';
import { ModificaListinoComponent } from './modifica/modifica-listino';
import { ModificaListinoNazionaleComponent } from './modifica/modifica-listino-nazionale';
import { list } from 'firebase/storage';
import { AggiungiRegioneComponent } from './aggiungi-regione/aggiungi-configurazione';
import { ModificaRegioneComponent } from './modifica-regione/modifica-regione';
import { StoricoNazionaleComponent } from './storico/storico-nazionale';
import { StoricoListinoComponent } from './storico/storico-listino';

@Component({
    templateUrl: './listino.component.html',
    styleUrls: ['./listino.component.css'],
    providers: [DialogService, ConfirmationService, MessageService],

})
export class ListinoComponent implements OnInit, OnDestroy {
    protected isLoadingResults:boolean = false;
    protected showDeleteConfirmation:boolean = false;
    protected showDeleteConfigurazioneConfirmation:boolean = false;
    protected selectedRegione:string = "";
    protected azioniListinoNazionale:MenuItem[]; 

    protected selectedTabIndex: number = 0;
    protected listini:Listino[] = [];
    protected listiniLiguria:Listino[] = [];
    protected listiniPiemonte:Listino[] = [];
    protected listiniSardegna:Listino[] = [];

    protected selectedListino:Listino ;
    protected selectedListinoLiguria:Listino ;
    protected selectedListinoPiemonte:Listino ;
    protected selectedListinoSardegna:Listino ;
    private ref: DynamicDialogRef;

    @ViewChild("listiniDT", { static: true }) listiniDT: any;
    @ViewChild("listiniLiguriaDT", { static: true }) listiniLiguriaDT: any;
    @ViewChild("listiniPiemonteDT", { static: true }) listiniPiemonteDT: any;
    @ViewChild("listiniSardegnaDT", { static: true }) listiniSardegnaDT: any;

    public isDirigenteFirmaPacchetti: boolean   = false;
    public isDemo: boolean = false;

    constructor(
        private logger: NGXLogger,
        private dialogService: DialogService,
        private messageService: MessageService,
        private router: Router,
        private listiniService:ListiniService,
        protected utilService:UtilService
    ) {
      if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_PACCHETTI"
      ) {
        this.isDirigenteFirmaPacchetti = true;
      }else if(localStorage.getItem("ruolo") && localStorage.getItem("ruolo") === "DEMO"){
        this.isDemo = true;
      }
    }

    ngOnDestroy(): void {
    }

    ngOnInit() {
        this.loadListini();
        this.azioniListinoNazionale = [
          {
              label: 'QGIS',
              icon: 'pi pi-map',
              command: () => {  this.openModificaListinoNazionaleDialog()}
          },
          {
              label: 'Istruzioni',
              icon: 'pi pi-file-word',
              command: () => { this.openStoricoListinoNazionale()}
          }


];
    }
    onTabChange(event: TabViewChangeEvent) {
      this.selectedTabIndex = event.index;
      this.selectedListinoLiguria = null;
      this.selectedListinoPiemonte = null;
      this.selectedListinoSardegna = null;
      if(event.index==1){
        
        //dovrei filtrare e mostrare solo i listini della liguria
        this.listiniLiguria = this.listini.filter(listino => listino.liguria1 || listino.liguria2 || listino.liguria3 || listino.liguria4 || listino.liguria5);
      }else if(event.index==2){
        //dovrei filtrare e mostrare solo i listini della liguria
        this.listiniPiemonte = this.listini.filter(listino => listino.piemonte1 || listino.piemonte2 || listino.piemonte3 || listino.piemonte4 || listino.piemonte5);
      }else if(event.index==3){
        //dovrei filtrare e mostrare solo i listini della liguria
        this.listiniSardegna = this.listini.filter(listino => listino.sardegna1 || listino.sardegna2 || listino.sardegna3 || listino.sardegna4 || listino.sardegna5);
      }
    }

    loadListini(){
        this.logger.info("[LISTINO] LOADING ODA");
        this.isLoadingResults = true;
         this.listiniService.get().subscribe( {
            next: (res) => {
                this.listini = res;
                this.listiniLiguria = this.listini.filter(listino => listino.liguria1 || listino.liguria2 || listino.liguria3 || listino.liguria4 || listino.liguria5);
                this.listiniPiemonte = this.listini.filter(listino => listino.piemonte1 || listino.piemonte2 || listino.piemonte3 || listino.piemonte4 || listino.piemonte5);
                this.listiniSardegna = this.listini.filter(listino => listino.sardegna1 || listino.sardegna2 || listino.sardegna3 || listino.sardegna4 || listino.sardegna5);

            },
            error: (e) => {
                this.logger.info(e);
              this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di caricamento dei listini'});
              this.isLoadingResults = false;
          },
            complete: () => {

              this.isLoadingResults = false;
            }
        }); 
    }
    openListinoRegione(regione:string, listino:Listino){
      if(regione==='LIGURIA'){
        this.listiniLiguria = this.listini.filter(listino => listino.liguria1 || listino.liguria2 || listino.liguria3 || listino.liguria4 || listino.liguria5);
        this.selectedListinoLiguria = listino;
        this.selectedTabIndex = 1;
      }else if(regione==='PIEMONTE'){
        this.selectedTabIndex = 2;
        this.selectedListinoPiemonte = listino;
        this.listiniPiemonte = this.listini.filter(listino => listino.piemonte1 || listino.piemonte2 || listino.piemonte3 || listino.piemonte4 || listino.piemonte5);
      }else if(regione==='SARDEGNA'){
        this.selectedTabIndex = 3;
        this.selectedListinoSardegna = listino;
        this.listiniSardegna = this.listini.filter(listino => listino.sardegna1 || listino.sardegna2 || listino.sardegna3 || listino.sardegna4 || listino.sardegna5);

      }
    }

    filtraListini(event: any){
      this.listiniDT.filterGlobal(event.target.value, 'contains');
      this.listiniLiguriaDT.filterGlobal(event.target.value, 'contains');
      this.listiniPiemonteDT.filterGlobal(event.target.value, 'contains');
      this.listiniSardegnaDT.filterGlobal(event.target.value, 'contains');
    }

    isRowLiguriaSelected(listino:Listino) : boolean{
      return this.selectedListinoLiguria && this.selectedListinoLiguria.id === listino.id;
    }
    isRowPiemonteSelected(listino:Listino) : boolean{
      return this.selectedListinoPiemonte && this.selectedListinoPiemonte.id === listino.id;
    }
    isRowSardegnaSelected(listino:Listino) : boolean{
      return this.selectedListinoSardegna && this.selectedListinoSardegna.id === listino.id;
    }

    impresaHaRegioniLibere(listino:Listino) : boolean{
      let haRegioniLibere = false;
      
      if(!listino.piemonte1 || !listino.liguria1 || !listino.sardegna1){
        haRegioniLibere = true;
      }
      return haRegioniLibere;
    }

    openCreaListinoDialog(){
      this.logger.info(this.listini);
      this.logger.info(this.listini.map(listino => listino.azienda));
       this.ref = this.dialogService.open(CreaListinoComponent, {
        data:{
          aziendeConListino:this.listini
          .map(listino => listino.azienda) 
        },
        header: "Nuovo Listino Prezzi",
        width:  "90%" ,
        height: "60%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((confirmNewAzienda) => {
          console.log("AFTER CLOSED > "+ confirmNewAzienda.success);
        if (confirmNewAzienda && confirmNewAzienda.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Listino creato con successo!', life:3000});
          this.loadListini();
        }
      });  
  } 

  showDeleteConfigurazioneDialog(listino: Listino, regione:string){
    this.showDeleteConfigurazioneConfirmation = true;
    this.selectedListino = listino;
    this.selectedRegione = regione;
  }

  
  confermaEliminazioneConfigurazione(){
    this.showDeleteConfigurazioneConfirmation = false;
    this.isLoadingResults = true;
   
    this.listiniService.eliminaConfigurazione(this.selectedListino.id.toString(), this.selectedRegione).subscribe( {
      next: (v) => {

      },
      error: (e) => {
          this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di eliminazione della configurazione per la regione '+ this.selectedRegione});
          this.isLoadingResults = false;
      },
      complete: () => {
          this.messageService.add({severity:'success', summary:'', detail:'Configurazione per la regione '+this.selectedRegione+' eliminata!', life:5000});
          this.loadListini();
          this.isLoadingResults = false;
          
      }
  });
  }

  showDeleteListinoDialog(listino: Listino): void {
    this.showDeleteConfirmation = true;
    this.selectedListino = listino;
    this.logger.info(this.selectedListino);
   }

   confermaEliminazioneListino(){
    this.showDeleteConfirmation = false;
    this.isLoadingResults = true;
    this.listiniService.elimina(this.selectedListino.id.toString()).subscribe( {
        next: (v) => {

        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di eliminazione del listino'});
            this.isLoadingResults = false;
        },
        complete: () => {
            this.messageService.add({severity:'success', summary:'', detail:'Listino eliminato!', life:5000});
            this.loadListini();
            this.isLoadingResults = false;
            
        }
    });

  }

  openModificaRegioneDialog(listino: Listino, regione:string){
    this.ref = this.dialogService.open(ModificaRegioneComponent, {
      data: {
        listino: listino,
        regione: regione
        },
      header: "Modifica regione del Listino dell'impresa "+listino.azienda.ragioneSociale.toUpperCase(),
      width:  "70%" ,
      height: "60%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((confirmModificaListino) => {
       console.log("AFTER CLOSED > "+ confirmModificaListino.success);
      if (confirmModificaListino && confirmModificaListino.success) {
        this.messageService.add({severity:'success', summary:'', detail:'Listino modificato con successo!', life:3000});
        this.loadListini();
      }
    }); 
  }
  openAggiungiRegioneDialog(listino: Listino){
    this.ref = this.dialogService.open(AggiungiRegioneComponent, {
      data: {
        listino: listino,
        },
      header: "Aggiungi regione al Listino dell'impresa "+listino.azienda.ragioneSociale.toUpperCase(),
      width:  "70%" ,
      height: "60%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((confirmModificaListino) => {
       console.log("AFTER CLOSED > "+ confirmModificaListino.success);
      if (confirmModificaListino && confirmModificaListino.success) {
        this.messageService.add({severity:'success', summary:'', detail:'Listino modificato con successo!', life:3000});
        this.loadListini();
      }
    }); 
  }
 
  openStoricoListinoNazionale(){
    this.ref = this.dialogService.open(StoricoNazionaleComponent, {
    
      header: "Storico del Listino Nazionale",
      width:  "60%" ,
      height: "65%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
      this.ref.onClose.subscribe((confirmModificaAzienda) => {
        
      }); 
  }

  openStoricoListino(listino:Listino, regione:string){
    this.ref = this.dialogService.open(StoricoListinoComponent, {
      data: {
        listino: listino,
        regione: regione
        },
      header: "Storico del Listino dell'impresa "+listino.azienda.ragioneSociale.toUpperCase() + " in "+regione,
      width:  "60%" ,
      height: "65%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
      this.ref.onClose.subscribe((confirmModificaAzienda) => {
        
      }); 
  }

  openModificaListinoNazionaleDialog(){
    this.ref = this.dialogService.open(ModificaListinoNazionaleComponent, {
      data: {
        listino: this.listini[0].listinoNazionale,
        },
      header: "Modifica Listino Nazionale",
      width:  "60%" ,
      height: "35%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((confirmModificaAzienda) => {
       console.log("AFTER CLOSED > "+ confirmModificaAzienda.success);
      if (confirmModificaAzienda && confirmModificaAzienda.success) {
        this.messageService.add({severity:'success', summary:'', detail:'Listino modificato con successo!', life:3000});
        this.loadListini();
      }
    }); 
  }

  openModificaListinoDialog(listino: Listino): void {
    this.ref = this.dialogService.open(ModificaListinoComponent, {
        data: {
          listino: listino,
          },
        header: "Modifica Listino dell'impresa "+listino.azienda.ragioneSociale.toUpperCase(),
        width:  "70%" ,
        height: "60%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((confirmModificaAzienda) => {
         console.log("AFTER CLOSED > "+ confirmModificaAzienda.success);
        if (confirmModificaAzienda && confirmModificaAzienda.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Listino modificato con successo!', life:3000});
          this.loadListini();
        }
      }); 
} 


}